import { standardProfile } from "./standard-dealer";

export const toshibaProfile = {
    ...standardProfile,

    code: "Toshiba",

    orderCreation: {
        ...standardProfile.orderCreation,

        components: {
            ...standardProfile.orderCreation.components,

            orderOptions: {
                enabled: true,

                props: {
                    ...standardProfile.orderCreation.components.orderOptions.props,

                    showOrderTypeSelector: true,
                    showCustomerPickup: true
                }
            }
        }
    },

    getCarrierCode({ orderType, customerPickup }) {
        const isCustomerPickup = orderType === "STD" && customerPickup === true;
        return isCustomerPickup ? "RIT" : "ITM";
    }
};